__turbopack_context__.v({
  "countdown": "Notifications-module-scss-module__Ls8XmW__countdown",
  "notification": "Notifications-module-scss-module__Ls8XmW__notification",
  "notification-content": "Notifications-module-scss-module__Ls8XmW__notification-content",
  "notification-countdown": "Notifications-module-scss-module__Ls8XmW__notification-countdown",
  "notification-countdown-bar": "Notifications-module-scss-module__Ls8XmW__notification-countdown-bar",
  "notification-hide-btn": "Notifications-module-scss-module__Ls8XmW__notification-hide-btn",
  "notification-icon": "Notifications-module-scss-module__Ls8XmW__notification-icon",
  "notification-message": "Notifications-module-scss-module__Ls8XmW__notification-message",
  "notification-title": "Notifications-module-scss-module__Ls8XmW__notification-title",
  "notifications": "Notifications-module-scss-module__Ls8XmW__notifications",
});
